import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IDropTypeResponse } from "@miplatform/types";

export const useDropTypesViewModel = () => {
  const stateManager = useComponentState();

  const [selectedDropType, setSelectedDropType] =
    useState<IDropTypeResponse | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const handleDeleteDropType = (dropType: IDropTypeResponse) => {
    stateManager.run(async () => {
      const response = await homeService.dropTypes.delete({
        id: dropType.id,
        modifiedOn: dropType.modifiedOn,
        toastMessageConfig: {
          success: {
            text: `${dropType.name} was deleted successfully.`,
            failure: {
              text: `Failed to delete ${dropType.name}.`,
            },
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        setRefresh((prev) => !prev);
        setSelectedDropType(null);
      }
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    selectedDropType,
    showDeleteModal,
    refresh,
    setRefresh,
    setSelectedDropType,
    setShowDeleteModal,
    handleDeleteDropType,
  };
};
